import React, {useRef, useState} from "react";
import {GridProps} from "../GridProps";

import moment from "moment";
import {IonButton, IonIcon, useIonToast} from "@ionic/react";
import {checkmark, map, search, trash} from "ionicons/icons";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {sendDeleteQuery} from "../hooks/sendDeleteQueryHook";
import FileSaver from 'file-saver';
import xlsx from "xlsx";
import {jsPDF} from "jspdf";
import 'jspdf-autotable';
import {InputText} from "primereact/inputtext";
import {FilterMatchMode, FilterOperator} from 'primereact/api';

export const BidInboundData: React.FC<GridProps> = ({data, editItem, refreshList, user}) => {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [bidData, setBidData] = useState({bidItems: []});
    const [showForm, setShowForm] = useState(false);
    const [present] = useIonToast();
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [compState, setCompState] = useState<{
        onlyBids: boolean,
        curData: any[],
        toDelete: any[],
        showToast: boolean,
        toastMessage: string
    }>({
        showToast: false,
        toastMessage: "",
        onlyBids: false,
        curData: [],
        toDelete: []
    });
    //'purchaseOrderNumber', 'city', 'state'
    const [filters, setFilters] = useState({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        purchaseOrderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        city: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        state: {value: null, matchMode: FilterMatchMode.STARTS_WITH}
    });
    const formatMoney = (number: any) => {
        return number?.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    };
    const filterDate = (value: string, filter: any) => {
        if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
            return true;
        }

        if (value === undefined || value === null) {
            return false;
        }
        return moment(value).format("M/D/YY") === formatDate(filter);
    };

    const formatDate = (date: Date) => {
        let month: number = (date.getMonth() + 1);
        let day: number = (date.getDate());
        let monthstr: string = (date.getMonth() + 1).toString();
        let daystr: string = (date.getDate()).toString();

        if (month < 10) {
            monthstr = '0' + month.toString();
        }
        if (day < 10) {
            daystr = '0' + day.toString();
        }
        return moment(date).format("M/D/YY")

    };
    const dt = useRef(null);
    const onDateChange = (e: any) => {
        let current: any = dt.current;
        if (current !== null) {
            current.filter(e.value, 'dateReq', 'custom');
            setSelectedDate(e.value);
        }
    };
    const bookNowSetTemplate = (rowData: any) => {
        if (!rowData.bidItems)
            return <></>;
        let hasBookNow = rowData.bidItems.find((i: any) => {
            return i.IsBookNow
        });
        return <>
            {hasBookNow && <IonIcon style={{color: "green"}} icon={checkmark}></IonIcon>}
        </>
    }
    const actionsBody = (rowData: any) => {
        if (!rowData.bidItems)
            return <></>;
        let hasBookNow = rowData.bidItems.find((i: any) => {
            return i.IsBookNow
        });
        const editItem = (editItemData: any) => {
            setBidData({...editItemData});
            setShowForm(true);
        };
        return <>
            {rowData.bidItems && rowData.bidItems.length > 0 &&
                <IonButton onClick={() => editItem(rowData)}><IonIcon icon={search}></IonIcon></IonButton>}
            {hasBookNow && <IonButton onClick={() => editItem(rowData)}><IonIcon icon={trash}></IonIcon></IonButton>}
        </>
    };

    const dateDueBodyTemplate = (rowData: any) => {
        return (
            <>
                <span>{moment(rowData.dueDate).format("M/D/YY")}</span>
            </>
        );
    };
    const dateIssuedBodyTemplate = (rowData: any) => {
        return (
            <>
                <span>{moment(rowData.issueDate).format("M/D/YY")}</span>
            </>
        );
    };

    const hotloadTemplate = (rowData: any) => {
        return <><span><input type={"checkbox"} disabled={true} checked={rowData['hotLoad']}/></span></>;
    }
    const sendToBoardTemplate = (rowData: any) => {
        return <><span><input type={"checkbox"} disabled={true} checked={rowData['sendToBoard']}/></span></>;
    };
    const mapTemplate = (rowData: any) => {
        return <><IonButton href={rowData['mapLink']} target={"_blank"} color="secondary"><IonIcon icon={map}></IonIcon></IonButton></>
    };
    const deleteItem = async (bid: any) => {
        await sendDeleteQuery(bid, user);
        refreshList();
        setShowForm(false)
    };

    const exportCSV = (selectionOnly: any) => {
        let item: any = dt.current;
        item.exportCSV({selectionOnly});
    };
    const cols: any[] = [
        {title: "PO #", dataKey: "purchaseOrderNumber"},
        {title: "CITY", dataKey: "city"},
        {title: "STATE", dataKey: "state"},
        {title: "HOT LOAD", dataKey: "hotLoad"},
        {title: "Tarped", dataKey: "tarpRequired"},
        {title: "BOOK RATE", dataKey: "bookNowRate"}
    ];
    const exportPdf = () => {
        const exportColumns = cols;

        const doc: any = new jsPDF("landscape", "px");
        doc.autoTable(exportColumns, data);
        doc.save('products.pdf');

    };
    const exportExcel = () => {

        let dataMapped: any[] = data.map(i => {
            return {
                orderID: i.orderID,
                city: i.city,
                state: i.state,
                hotLoad: i.hotLoad,
                miles: i.miles,
                bookNowRate: i.bookNowRate
            }
        });
        dataMapped.unshift({});
        const worksheet = xlsx.utils.json_to_sheet(dataMapped, {skipHeader: true});
        xlsx.utils.sheet_add_aoa(worksheet, [["ORDER #", "CITY", "STATE", "HOT LOAD", "MILES", "BOOK NOW RATE"]]); //heading: array of arrays
        const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        saveAsExcelFile(excelBuffer, 'products');

    };

    const saveAsExcelFile = (buffer: any, fileName: any) => {

        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);

    };
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        let _filters: any = {...filters};

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const header = (
        <div className="flex gap-2 items-center  p-ai-center export-buttons">
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success p-mr-2"
                    data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-warning p-mr-2"
                    data-pr-tooltip="PDF"/>

            <div className={"w-40"}>Auction Count: {data.length} </div>
            <div className={"w-full text-right"}>
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search"/>
            </div>
        </div>
    );
    const bookNowTemplate = (rowData: any) => {
        return <><span>{formatMoney(rowData['bookNowRate'])}</span></>;
    };
    const tarpedTemplate = (rowData: any) => {
        return <><span><input type={"checkbox"} disabled={true} checked={rowData['tarpRequired']}/></span></>;
    }
    const orderTemplate = (rowData: any) => {
        if (rowData.shipWeight > 40000)
            return <><span style={{fontWeight: 800}}> {rowData.purchaseOrderNumber}</span></>
        return <>{rowData.orderID}</>
    };
    const deleteAll = async () => {
        for (let i = 0; i < compState.toDelete.length; i++) {
            await sendDeleteQuery(compState.toDelete[i], user);
        }

        await refreshList();
        await present({
            message: "Bid Deleted Successfully",
            duration: 3000,
            position: 'bottom',
        });
        setCompState({...compState, toDelete: []});
    }
    const addToDelete = (toAdd: boolean, item: any) => {
        const tmp = !toAdd ? [...compState.toDelete].filter(i => i.BidId !== item.BidId) : [...compState.toDelete, item];
        setCompState({...compState, toDelete: tmp})
    }
    const dateFilter = <Calendar value={selectedDate} onChange={onDateChange} dateFormat="mm/dd/yy"
                                 className="p-column-filter" placeholder="Registration Date"/>;
    return <>
        <Dialog header="Active Bids" visible={showForm} style={{width: '50vw'}} onHide={() => setShowForm(false)}>
            <button
                className={compState.toDelete.length > 0 ? "p-button" : "py-2 px-3 border rounded bg-gray-300 text-white"}
                disabled={compState.toDelete.length === 0}
                onClick={async () => await deleteAll()}>Delete All
            </button>
            <div className={"items-center gap-2 grid grid-cols-5"}>
                <div className={"text-center w-20"}>Actions</div>
                <div className={"text-center "}>Email</div>
                <div className={"text-center"}>Rate</div>
                <div className={"text-center"}>Is Book Now</div>
                <div className={"text-center"}>Date</div>
            </div>
            {(bidData.bidItems || []).map((itemInfo: any) => {
                return <div className={"items-center gap-2 grid grid-cols-5"}>
                    <div className={"text-center w-20"}>
                        <input type={"checkbox"} className={"p-2 border border-gray-500 box-border size-5"}
                               checked={compState.toDelete.find(i => i.BidId === itemInfo.BidId)}
                               onClick={(e: any) => {
                                   addToDelete(e.target.checked, itemInfo)
                               }}/>

                    </div>
                    <div className={"text-left w-[20rem]"}>
                        {itemInfo.UserId}
                    </div>
                    <div className={"text-right"}>
                        {formatMoney(itemInfo.BidAmount)}
                    </div>
                    <div className={"font-bold ml-3 text-center"}>
                        {itemInfo.IsBookNow && <span>Yes</span>}
                    </div>
                    <div>
                        {itemInfo.BidDateTime ? moment(itemInfo.BidDateTime).format("MM/DD/YYYY hh:mm A") : ""}
                    </div>
                </div>;
            })}
        </Dialog>
        <DataTable header={header} ref={dt} value={data} filters={filters} lazy totalRecords={data.length}
                   globalFilterFields={['purchaseOrderNumber', 'city', 'state']}
                   currentPageReportTemplate="{totalRecords} total trucks">
            <Column field="purchaseOrderNumber" header="PO #" sortable filter body={orderTemplate}></Column>
            <Column field="dueDate" header="Due Date" sortable filter body={dateDueBodyTemplate}
                    filterElement={dateFilter} filterFunction={filterDate}></Column>
            <Column field="issueDate" header="Issue Date" sortable filter body={dateIssuedBodyTemplate}
                    filterElement={dateFilter} filterFunction={filterDate}></Column>
            <Column field="city" header="City" sortable filter></Column>
            <Column field="state" header="State" sortable filter></Column>
            <Column field="mapLink" header="Map" body={mapTemplate}></Column>
            <Column field="bookNowRate" header="BOOK NOW" sortable filter body={bookNowTemplate}></Column>
            <Column field="tarpRequired" header="Tarped?" sortable body={tarpedTemplate}></Column>
            <Column field="hotLoad" header="Hot Load?" sortable body={hotloadTemplate}></Column>
            <Column field="actions" header="Actions" body={actionsBody}></Column>
        </DataTable>

    </>;
};